<div class="if-unit-toggle" [class.if-unit-toggle--disabled]="disabled()">
  @for (option of options(); track option) {
    <button
      type="button"
      class="if-unit-toggle__btn"
      [class.if-unit-toggle__btn--active]="value() === option"
      [disabled]="disabled()"
      (click)="select(option)">
      {{ option }}
    </button>
  }
</div>
